import React from "react";
import { Modal } from "react-bootstrap";

const ServiceFormHeader = ({ onClose }) => {
  return (
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: "24px", fontWeight: "bold" }}>
        Tambah Service Baru
      </Modal.Title>
    </Modal.Header>
  );
};

export default ServiceFormHeader;
